import { GlobalState } from '@store';

import { IReviewItem } from '@sravni/react-seo';

export const getReviewsFromState = (state: GlobalState): IReviewItem[] => state.reviews.list;
